module.exports = __webpack_public_path__ + "static/media/NDVIInactive.6496ac3a.png";